import { render } from "./SolutionDetailISIGN.vue?vue&type=template&id=33c09a1a"
import script from "./SolutionDetailISIGN.vue?vue&type=script&lang=js"
export * from "./SolutionDetailISIGN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__